"use client";

import FacilitiesLinks from "./facilitiesLinks";
import Sustainability from "./sustainability";
import Brands from "./brands";

export default function HomeBelowFoldLazy() {
    return (
        <>
            <FacilitiesLinks />
            <Sustainability />
            <Brands />
        </>
    );
}
